import $ from 'jquery';

export function openPopup(opener, popup) {
    const bodyOverflow = $('body');
    const closePopup = $('.popup__close');

    if(popup === ".popup-cv")
    {
        let fileLable = $(popup).find(".download-label");
        let fileNameFiled = $(popup).find(".file-name");
        let fileInput = $(fileLable).find(".download-label-inner-wrapper").find(".file-input");
        $(fileInput).change(function() {
            let fileName = $(fileInput).prop('files')[0].name;
            $(fileNameFiled).text(fileName);
        })
    }
    
    $(opener).on('click', function () {
        $(popup).addClass('active');
        bodyOverflow.addClass('overflow');
    })
  

    closePopup.on('click', function () {
        $(popup).removeClass('active');
        if(!$(".header__content").hasClass("open"))
            bodyOverflow.removeClass('overflow');

    })
}


// WEBPACK FOOTER //
// app/scripts/components/popup.js